export const defaultSearchTypes = [
  'randomized_trial',
  'meta_analysis',
  'systematic_review',
  'human_intervention',
];
